var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgByUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0052 1.04102C7.81908 1.04102 6.04688 2.81322 6.04688 4.99935C6.04688 7.18548 7.81908 8.95768 10.0052 8.95768C12.1913 8.95768 13.9635 7.18548 13.9635 4.99935C13.9635 2.81322 12.1913 1.04102 10.0052 1.04102ZM7.29688 4.99935C7.29688 3.50358 8.50944 2.29102 10.0052 2.29102C11.501 2.29102 12.7135 3.50358 12.7135 4.99935C12.7135 6.49512 11.501 7.70768 10.0052 7.70768C8.50944 7.70768 7.29688 6.49512 7.29688 4.99935Z",
    fill: "#5A5FA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50521 10.2077C5.31908 10.2077 3.54688 11.9799 3.54688 14.166C3.54688 16.3521 5.31908 18.1243 7.50521 18.1243H12.5052C14.6913 18.1243 16.4635 16.3521 16.4635 14.166C16.4635 11.9799 14.6913 10.2077 12.5052 10.2077H7.50521ZM4.79688 14.166C4.79688 12.6702 6.00944 11.4577 7.50521 11.4577H12.5052C14.001 11.4577 15.2135 12.6702 15.2135 14.166C15.2135 15.6618 14.001 16.8743 12.5052 16.8743H7.50521C6.00944 16.8743 4.79688 15.6618 4.79688 14.166Z",
    fill: "#5A5FA0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgByUser);
export default __webpack_public_path__ + "static/media/byUser.332dad310259009ece5467d49d2a5e98.svg";
export { ForwardRef as ReactComponent };